module.exports = __webpack_public_path__ + "img/icon-checkin.610c4d04.svg";